import { createClient } from '@supabase/supabase-js';

// Public by design: the URL and the anon key end up in the browser bundle
// anyway, and the database only exposes what RLS and get_ai_report allow.
// They are defaults so any deploy works without configuring variables;
// VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY override them.
const DEFAULT_URL = 'https://tzopzjmpgjbxazuvcuhj.supabase.co';
const DEFAULT_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR6b3B6am1wZ2pieGF6dXZjdWhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA2OTE1MTEsImV4cCI6MjEwNjI2NzUxMX0.Flw5G3WuUkPCDL74Qn4AUV5CymeDaZQL-h0akXHxaBE';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || DEFAULT_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || DEFAULT_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Without these variables the app must still render (landing page, example
// report); features that need the backend report themselves as unavailable
// instead of the whole page failing to load.
if (!isSupabaseConfigured) {
  console.error('Supabase no está configurado: faltan VITE_SUPABASE_URL y/o VITE_SUPABASE_ANON_KEY.');
}

export const supabase = isSupabaseConfigured ? createClient(supabaseUrl, supabaseAnonKey) : null;
